import React from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";

const decorate = connect(() => ({}));

const Editing = ({}) => {
  return (
    <Div bg="warning2" bra={2} p={3} mb={3} display="row.center.center">
      You are editing your existing submission
    </Div>
  );
};

export default decorate(Editing);
